import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { withCookies } from 'react-cookie'

import Fab from 'cityads-v3/components/Fab/Fab';

import { authRegexp } from 'cityads-v3/utils/authUtils';

@withCookies
@withRouter
@connect(
  state => ({
    fabShow   : state.fab.show,
    isLoggedIn: state.auth.isLoggedIn,
  })
)
@withTranslation(['main'], { i18n, wait: !!window })
export default class AppFabContainer extends PureComponent {
  static propTypes = {
    t         : PropTypes.func.isRequired,
    location  : PropTypes.object.isRequired,
    fabShow   : PropTypes.bool,
    isLoggedIn: PropTypes.bool,
  };


  render() {
    const { t, location, fabShow, isLoggedIn, cookies } = this.props;
    const { pathname, ...rest } = location;
    const pathnameNoRegister = pathname.replace(authRegexp, '');
    const FEATURE_BLOGGER_REGISTRATION = !!cookies?.cookies?.FEATURE_BLOGGER_REGISTRATION;

    const publisher = [{
      title: t('publisher'),
      icon: 'web',
      href: {
        ...rest,
        pathname: pathnameNoRegister + '/register/publisher',
        state: {
          source: 'AppFabContainer'
        }
      },
    }]

    const advertiser = [{
      title: t('advertiser'),
      icon: 'adv',
      href: {
        ...rest,
        pathname: pathnameNoRegister + '/register/advertiser',
        state: {
          source: 'AppFabContainer'
        }
      },
    }]

    const blogger = FEATURE_BLOGGER_REGISTRATION ? [{
      title: t('blogger'),
      icon: 'blogger',
      href: {
        ...rest,
        pathname: pathnameNoRegister + '/register/blogger',
        state: {
          source: 'AppFabContainer'
        }
      },
    }] : []

    return (
      <Fab
        show={!isLoggedIn && fabShow}
        items={[
          ...publisher,
          ...advertiser,
          ...blogger,
        ]}
      />
    );
  }
}
